<template>
  <div>
    <template v-if="item">
      <v-card class="py-2 px-3 mb-2" elevation="0" color="#eee">
        <v-layout wrap align-center>
          <v-flex xs8>{{ item.reason }}</v-flex>
          <v-flex xs1>{{ item.count }}</v-flex>
          <v-flex xs1>{{ item.percent }}%</v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn flat small color="primary" @click="ticketByReasonDialogOpen = true"
              >More detail</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card>
    </template>

    <v-dialog v-model="ticketByReasonDialogOpen" width="1200px" persistent>
      <DialogTicketByReason
        v-if="ticketByReasonDialogOpen"
        :item="reasonItem"
        @close="ticketByReasonDialogOpen = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import DialogTicketByReason from './DialogTicketByReason.vue'
export default {
  components: {
    DialogTicketByReason
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    level: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ticketByReasonDialogOpen: false
    }
  },
  computed: {
    reasonItem() {
      return {
        level: this.level,
        reason: this.item.reason
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/nt/Reason/ReasonItemCard.vue